import { MixerPanel } from "../components/MixerPanel";
import { ProgressionEditor } from "../components/ProgressionEditor";
import { StepGrid } from "../components/StepGrid";
import { SynthPanel } from "../components/SynthPanel";
import { useProject } from "../context";

export function Studio() {
  const chordsTrack = useProject((p) => p.sequence.progression.trackId);
  return (
    <div className="workspace-grid studio">
      <StepGrid />
      <ProgressionEditor />
      <SynthPanel trackId={chordsTrack} title="Chords sound" />
      <MixerPanel />
    </div>
  );
}
